<template>
    <div>
        <div v-html="content" class="text-editor ck-content"></div>
    </div>
</template>
<script>
    import '@ckeditor/ckeditor5-basic-styles/theme/code.css'
    import '@ckeditor/ckeditor5-block-quote/theme/blockquote.css'
    import '@ckeditor/ckeditor5-code-block/theme/codeblock.css'
    import '@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css'
    import '@ckeditor/ckeditor5-engine/theme/placeholder.css'
    import '@ckeditor/ckeditor5-font/theme/fontcolor.css'
    import '@ckeditor/ckeditor5-font/theme/fontsize.css'
    import '@ckeditor/ckeditor5-heading/theme/heading.css'
    import '@ckeditor/ckeditor5-highlight/theme/highlight.css'
    import '@ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css'
    import '@ckeditor/ckeditor5-image/theme/image.css'
    import '@ckeditor/ckeditor5-image/theme/imagecaption.css'
    import '@ckeditor/ckeditor5-image/theme/imageresize.css'
    import '@ckeditor/ckeditor5-image/theme/imagestyle.css'
    import '@ckeditor/ckeditor5-image/theme/imageuploadicon.css'
    import '@ckeditor/ckeditor5-image/theme/imageuploadloader.css'
    import '@ckeditor/ckeditor5-image/theme/textalternativeform.css'
    import '@ckeditor/ckeditor5-link/theme/link.css'
    import '@ckeditor/ckeditor5-link/theme/linkactions.css'
    import '@ckeditor/ckeditor5-link/theme/linkform.css'
    import '@ckeditor/ckeditor5-link/theme/linkimage.css'
    import '@ckeditor/ckeditor5-list/theme/todolist.css'
    import '@ckeditor/ckeditor5-media-embed/theme/mediaembed.css'
    import '@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css'
    import '@ckeditor/ckeditor5-media-embed/theme/mediaform.css'

    import '@ckeditor/ckeditor5-table/theme/colorinput.css'
    import '@ckeditor/ckeditor5-table/theme/form.css'
    import '@ckeditor/ckeditor5-table/theme/formrow.css'
    import '@ckeditor/ckeditor5-table/theme/inserttable.css'
    import '@ckeditor/ckeditor5-table/theme/table.css'
    import '@ckeditor/ckeditor5-table/theme/tablecellproperties.css'
    import '@ckeditor/ckeditor5-table/theme/tableediting.css'
    import '@ckeditor/ckeditor5-table/theme/tableform.css'
    import '@ckeditor/ckeditor5-table/theme/tableproperties.css'
    import '@ckeditor/ckeditor5-table/theme/tableselection.css'
    import '@ckeditor/ckeditor5-widget/theme/widget.css'
    import '@ckeditor/ckeditor5-widget/theme/widgetresize.css'
    import '@ckeditor/ckeditor5-widget/theme/widgettypearound.css'
    export default {
        name:"ckeditorView",
        props:{
            content:{
                type: String,
                required: true
            }
        },
        methods:{},
        mounted(){}
    }
</script>
<style>
    img{
        cursor:pointer
    }
</style>